export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  imageQuery: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "洛丽塔服饰文化",
    slug: "lolita-culture",
    description: "深入探索洛丽塔时尚的起源、流派演变与文化内涵，从维多利亚时代的浪漫到现代街头的甜美演绎。",
    imageQuery: "Elegant%20Lolita%20fashion%20dress%20with%20lace%20and%20ribbons%2C%20vintage%20inspired%20doll%20like%20silhouette%2C%20soft%20pastel%20background%20with%20scattered%20rose%20petals%2C%20delicate%20feminine%20aesthetic%2C%20editorial%20fashion%20photography%20with%20dreamy%20atmosphere%2C%20high%20detail%20fabric%20texture",
    articleCount: 8
  },
  {
    id: "cat-2",
    name: "甜美系穿搭",
    slug: "sweet-style",
    description: "掌握甜美系穿搭的核心法则，从色彩搭配到层次叠穿，打造让人心动的梦幻造型。",
    imageQuery: "Sweet%20kawaii%20fashion%20outfit%20with%20pink%20dress%20and%20frills%2C%20cute%20accessories%20with%20bows%2C%20soft%20cotton%20candy%20colored%20background%2C%20dreamy%20pastel%20aesthetic%2C%20whimsical%20and%20playful%20mood%2C%20editorial%20fashion%20photography%2C%20high%20detail",
    articleCount: 10
  },
  {
    id: "cat-3",
    name: "日系少女风",
    slug: "japanese-girly",
    description: "解锁日系少女风格的穿搭密码，从原宿街拍到杂志封面，找到属于你的日系灵感。",
    imageQuery: "Japanese%20harajuku%20girl%20fashion%20street%20style%2C%20layered%20outfit%20with%20pleated%20skirt%20and%20cute%20socks%2C%20urban%20Tokyo%20background%20with%20soft%20sunlight%2C%20youthful%20and%20trendy%20aesthetic%2C%20editorial%20fashion%20photography%2C%20clean%20composition",
    articleCount: 7
  },
  {
    id: "cat-4",
    name: "复古蕾丝搭配",
    slug: "vintage-lace",
    description: "蕾丝、荷叶边、珍珠扣——复古元素在现代穿搭中的巧妙运用，优雅中不失少女感。",
    imageQuery: "Vintage%20lace%20fashion%20detail%20with%20pearl%20buttons%20and%20delicate%20embroidery%2C%20antique%20inspired%20blouse%20with%20ruffle%20collar%2C%20warm%20cream%20background%20with%20dried%20flowers%2C%20romantic%20nostalgic%20aesthetic%2C%20editorial%20photography%2C%20soft%20natural%20light",
    articleCount: 6
  },
  {
    id: "cat-5",
    name: "配件搭配",
    slug: "accessories",
    description: "蝴蝶结、发带、手袋、袜子——精致配件是萝莉风格的灵魂，学会用细节提升整体造型。",
    imageQuery: "Cute%20lolita%20accessories%20collection%20with%20hair%20bows%20headbands%20and%20lace%20gloves%2C%20delicate%20handbag%20and%20frilly%20socks%20arranged%20on%20vanity%20table%2C%20soft%20pink%20background%20with%20fairy%20lights%2C%20feminine%20and%30detail%20oriented%20aesthetic%2C%20editorial%20still%20life%20photography",
    articleCount: 5
  }
];